import { get, put, post, destroy } from "./_utils";

export const getSubmissions = (formId, data = {}) => {
  return get(`/forms/${formId}/submissions.json`, data);
};

export const getSubmission = (formId, submissionId) => {
  return get(`/forms/${formId}/submissions/${submissionId}.json`);
};

export const updateSubmission = (formId, submissionId, data) => {
  return put(`/forms/${formId}/submissions/${submissionId}.json`, data);
};

export const markSubmissionSpam = (formId, submissionId) => {
  return post(`/forms/${formId}/submissions/${submissionId}/spam.json`);
};

export const markSubmissionHam = (formId, submissionId) => {
  return post(`/forms/${formId}/submissions/${submissionId}/ham.json`);
};

export const toggleSubmissionStar = (formId, submissionId, data) => {
  let postData = { is_starred: data };
  return post(
    `/forms/${formId}/submissions/${submissionId}/toggle_star.json`,
    postData,
  );
};

export const deleteSubmission = (formId, submissionId) => {
  return destroy(`/forms/${formId}/submissions/${submissionId}.json`);
};

export const markSubmissionsRead = (formId, data) => {
  let postData = { submission_ids: data };
  return post(`/forms/${formId}/submissions/mark_read.json`, postData);
};

export const getPresignedURLForSubmission = (fileName, uuid, draftId) => {
  let postData = { fileName, draftId };
  return post(`/forms/${uuid}/submissions/presign.json`, postData);
};

export const markAllSubmissionRead = (formId) => {
  return post(`/forms/${formId}/submissions/mark_all_read.json`);
};

export const markBulkSpam = (formId, data) => {
  let postData = { submission_ids: data };
  return post(`/forms/${formId}/submissions/mark_bulk_spam.json`, postData);
};

export const markBulkHam = (formId, data) => {
  let postData = { submission_ids: data };
  return post(`/forms/${formId}/submissions/mark_bulk_ham.json`, postData);
};

export const bulkDestroy = (formId, data) => {
  let postData = { submission_ids: data };
  return post(`/forms/${formId}/submissions/bulk_destroy.json`, postData);
};

export const regenerateEditToken = (formId, submissionId) => {
  return post(
    `/forms/${formId}/submissions/${submissionId}/regenerate_edit_token.json`,
  );
};

export const emailSubmissionEditLink = (formId, submissionId, data) => {
  return post(
    `/forms/${formId}/submissions/${submissionId}/email_submission_edit_link.json`,
    data,
  );
};

export const getSubmissionData = (formId, editToken) => {
  return get(`/forms/${formId}/submissions/${editToken}/edit.json`);
};

export const cloneSubmission = (formId, submissionId) => {
  return post(`/forms/${formId}/submissions/${submissionId}/clone.json`);
};

export const getCustomPdfPID = (formId, submissionIds) => {
  const url = `/forms/${formId}/submissions/custom_pdf.json?${submissionIds.map((id) => `submission_ids[]=${id}`).join("&")}`;
  return get(url);
};

export const getCustomPdfStatus = (formId, pid) => {
  return get(`/forms/${formId}/submissions/custom_pdf_status?pid=${pid}`);
};
